import React from 'react';
import { StyledBasketEmpty, StyledContinueShopping } from './styled';
import { useTranslation } from '~/shared/utils/translation';
import { useRouter } from 'next/router';
import { useFrame } from '~/shared/utils';

export const BasketEmpty = () => {
    const { translate } = useTranslation();
    const router = useRouter();
    const {
        data: { settings },
    } = useFrame();

    const storage = globalThis?.sessionStorage;
    const prevPath = storage?.getItem('prevPath');

    const handleBuyBtn = () => {
        const { hostname } = window.location;
        if (
            prevPath !== settings?.pageReferences?.checkoutPage?.url &&
            prevPath !== router.asPath &&
            prevPath?.includes(hostname)
        ) {
            router.back();
        } else {
            router.push('/');
        }
    };
    return (
        <StyledBasketEmpty>
            <h2>{translate('basket.emptyBasket')}</h2>
            <StyledContinueShopping variant="primary" onClick={handleBuyBtn}>
                {translate('basket.continueShopping')}
            </StyledContinueShopping>
        </StyledBasketEmpty>
    );
};
